import type { UIStringsOverride } from "../i18n-ui.ts";

/** Romanian (ro) UI strings. */
export const ro: UIStringsOverride = {
  actions: {
    addToCursor: "Adaugă în Cursor",
    addToVscode: "Adaugă în VS Code",
    askAI: "Întreabă AI despre această pagină",
    connectMcp: "Conectează-te la MCP",
    copied: "Copiat!",
    copyClaudeCode: "Copiază comanda Claude Code",
    copyCode: "Copiază codul",
    copyCodex: "Copiază comanda Codex",
    copyMarkdown: "Copiază ca Markdown",
    copyServerUrl: "Copiază URL-ul serverului",
    edit: "Editează pe GitHub",
    export: "Exportă",
    exportEpub: "Exportă ca EPUB",
    exportPdf: "Exportă ca PDF",
    generating: "Se generează…",
    openIn: "Deschide în {name}",
    openInChat: "Deschide în chat",
    scrollToTop: "Sus de tot",
  },
  ask: {
    ai: "AI",
    clear: "Șterge conversația",
    close: "Închide",
    copy: "Copiază conversația",
    empty: "Pune o întrebare despre documentație.",
    error: "Ne pare rău, ceva nu a mers bine.",
    label: "Pune o întrebare",
    placeholder: "Pune o întrebare…",
    send: "Trimite",
    tip: "Sfat: Poți deschide și închide chatul cu",
    title: "Întreabă AI",
    you: "Tu",
  },
  banner: { dismiss: "Închide anunțul" },
  changelog: {
    description: "Actualizări ale produsului și note de lansare.",
    showReleases: "Afișează lansările {version}",
    title: "Jurnal de modificări",
  },
  content: { diagramError: "Nu s-a putut reda această diagramă." },
  feedback: {
    no: "Nu",
    question: "Ți-a fost utilă această pagină?",
    thanks: "Mulțumim pentru feedback!",
    yes: "Da",
  },
  languageSwitcher: { label: "Limbă", untranslated: "Netradus" },
  nav: {
    back: "Înapoi",
    breadcrumb: "Cale de navigare",
    closeNavigation: "Închide navigarea",
    deprecated: "învechit",
    featured: "Recomandate",
    githubRepository: "Depozit GitHub",
    navigation: "Navigare",
    primary: "Principal",
    sections: "Secțiuni",
    toggleNavigation: "Comută navigarea",
    toggleTheme: "Comută tema de culoare",
  },
  notFound: {
    description: "Nu am găsit pagina pe care o cauți.",
    home: "Înapoi la pagina principală",
    title: "Pagina nu a fost găsită",
  },
  page: {
    lastUpdated: "Ultima actualizare",
    next: "Următorul",
    pagination: "Paginare",
    previous: "Anteriorul",
    skipToContent: "Sari la conținut",
  },
  search: {
    all: "Toate",
    allLanguages: "Toate limbile",
    askAi: "Întreabă AI",
    askAiHint: "Primește un răspuns instantaneu de la AI",
    button: "Caută",
    devOnly: "Căutarea este disponibilă în versiunea de producție.",
    error: "Ceva nu a mers bine. Încearcă din nou.",
    label: "Caută în documentație",
    navigate: "navighează",
    noResults: "Niciun rezultat găsit.",
    open: "deschide",
    placeholder: "Caută în documentație…",
    popular: "Populare",
    preview: "previzualizează",
    results: "Rezultate",
  },
  toc: { title: "Pe această pagină" },
};
